import styled, { css } from 'styled-components';
import { Button } from '@/assets/images';
import { Theme } from '@/theme';

type ButtonAttributes = {
  $secondary?: boolean;
  $primary?: boolean;
  disabled?: boolean;
  $purple?: boolean;
  $shadow?: boolean;
  $round?: boolean;
  $small?: boolean;
};

export default styled.button<ButtonAttributes>(
  ({ $secondary, $primary, disabled, $purple, $shadow, $round, $small }) => css`
    transition:
      opacity 0.3s,
      background-color 0.3s;

    font-family: ${Theme.font.family.speedee};
    background-color: ${Theme.color.orange};
    font-weight: ${Theme.font.weight.bold};

    line-height: ${Theme.rems(30)};
    backface-visibility: hidden;
    letter-spacing: 0.16px;

    border-radius: 50px;
    text-align: center;
    position: relative;

    margin: 0px auto;
    max-width: 218px;
    min-width: 40px;

    cursor: pointer;
    display: block;
    padding: 18px;

    height: 60px;
    width: 200px;

    ${$shadow &&
    css`
      box-shadow: 0px -4px #f1a139 inset;
    `}

    ${$secondary &&
    css`
      box-shadow: 0px -4px ${Theme.color.grey} inset;
      background-color: ${Theme.color.lightGrey};
    `}

    ${$purple &&
    css`
      background-color: ${Theme.color.purple};
      box-shadow: 0px -4px #4b0968 inset;
      color: ${Theme.color.white};
    `}

    ${$primary &&
    css`
      background-image: url('${Button}');
      background-repeat: no-repeat;
      background-position: center;
      background-color: unset;
      background-size: cover;
      box-shadow: none;
      width: 218px;
    `}

    ${$round &&
    css`
      width: 60px;
    `}

    ${$small &&
    css`
      width: 40px;
      height: 40px;
      padding: 11px;
      min-width: 40px;
      max-width: 40px;
    `}

    ${disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}

    ${!$primary &&
    css`
      &:active {
        background-color: ${Theme.color.yellow};

        ${$secondary &&
        css`
          background-color: ${Theme.color.white};
        `}

        ${$purple &&
        css`
          background-color: #a041c1;
        `}
      }
    `}
  `
);
